import { api } from "..";

import { QueryProps } from "@/types/Api";
import { NewUser } from "@/types/ApiResponses/User";

export interface GetPlayersQueryParams {}

export const getPlayers = async (
  props: QueryProps<GetPlayersQueryParams>
): Promise<NewUser[]> => {
  const res = await api.client.get("/users-new", {
    signal: props.signal,
  });
  return res.data;
};
